export var PermissionStatus;
(function (PermissionStatus) {
    PermissionStatus[PermissionStatus["unknown"] = 0] = "unknown";
    PermissionStatus[PermissionStatus["busy"] = 1] = "busy";
    PermissionStatus[PermissionStatus["allowed"] = 2] = "allowed";
    PermissionStatus[PermissionStatus["denied"] = 3] = "denied";
    PermissionStatus[PermissionStatus["banned"] = 4] = "banned";
})(PermissionStatus || (PermissionStatus = {}));
export const mapToPaymentActivity = (source, options) => source
    ? {
        type: 'DIRECT_PAYMENT',
        side: 'PAYER',
        status: source.status,
        amount: source.amount,
        canSendReminder: false,
        canThank: false,
        currency: source.currency,
        date: source.createdAt,
        paymentRequestId: 0,
        paymentId: source.id,
        activityUniqueId: source.id,
        counterparty: {
            firstName: source.payeeName,
            lastName: '',
            handle: '',
            email: '',
            phoneNumber: '',
        },
        reference: source.reference,
        options,
    }
    : undefined;
export const mapToUser = (handle, source) => source
    ? {
        id: -1,
        firstName: source.firstName,
        email: '',
        guessedHomeCountry: '',
        emmaProStatus: { active: false, usedFreeTrial: false },
        lastName: '',
        urlHandle: handle,
        pinLastChangedAt: null,
        isEmailVerified: false,
        phoneNumber: null,
        userOauths: [],
        dayStreak: 0,
        latestFeedbackDate: null,
    }
    : undefined;
export const mapBreakdownToPaymentActivity = (source, currency, isCredit, activityUniqueId) => ({
    amount: source.amount,
    currency,
    counterparty: source.counterparty,
    side: isCredit ? 'PAYEE' : 'PAYER',
    paymentRequestId: source.paymentRequest?.id ?? 0,
    type: 'PAYMENT_REQUEST',
    status: 'NOT_YET_ACTIONED',
    paymentRequestToken: source.paymentRequest?.token,
    activityUniqueId,
    paymentId: '',
    canSendReminder: !!('handle' in source.counterparty && source.counterparty.handle),
    canThank: false,
    date: source.paymentRequest?.createdAt ?? '',
    reference: source.paymentRequest?.message ?? '',
    options: {},
});
